import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const ImageIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg {...props} ref={ref} xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 18 18'><path fill='currentColor' d='M12.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z'/>
        <path fill='currentColor' d='M0 2a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm16 0H2v7.92l3.375-2.7a1 1 0 0 1 1.25 0l4.3 3.44 1.368-1.367a1 1 0 0 1 1.414 0L16 11.586V2ZM2 16h14v-1.586l-3-3-1.293 1.293a1 1 0 0 1-1.332.074L6 9.28l-4 3.2V16Z'/>
    </svg>
));
